export default __webpack_public_path__ + "76bb57ebd1d25429582513b18fbc9a31.svg";